//import "@fortawesome/fontawesome-free/css/all.css";
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import vuetify from "@/plugins/vuetify";
import VueGtag from "vue-gtag";
import VueCoreVideoPlayer from 'vue-core-video-player';
import AudioVisual from 'vue-audio-visual';
import i18n from '@/plugins/i18n';
import Embed from 'v-video-embed'

const es = {
    "dashboard": {
        "btn": {
            "play": "Play",
            "pause": "Pause",
            "fullscreen": "Full ScreenES",
            "exitFullscreen": "Exit Full Screen",
            "mute": "Mute",
            "unmute": "Unmute",
            "back": "Back",
            "pip": "Picture-in-PictureESS"
        },
        "settings": {
            "autoplay": "Autoplay",
            "loop": "Loop",
            "speed": "Speed",
            "resolution": "Resolution"
        }
    },
    "layers": {
        "error": {
            "title": "(O_O)?  Error!",
            "2404": "Video Source Not Found",
            "2502": "Media Network Error",
            "2503": "Video Cannot DECODE",
            "2504": "Video Cannot Play!"
        },
        "loading": {
            "msg": "Loading ..."
        }
    }
}

Vue.use(VueCoreVideoPlayer, {
    lang: i18n.locale
});


Vue.use(Embed);

Vue.use(AudioVisual);



Vue.use(VueGtag, {
    config: {
        id: "UA-127597741-1",
	params: {
     	 send_page_view: true
    	}
    }
});


Vue.config.productionTip = false;

new Vue({
    vuetify,
    i18n,
    render: h => h(App)
}).$mount("#app");
